import { i18n } from "@libs/i18n";
import { InvoiceDeliveryMethodType, PayerGroupType } from "@/domain/payer";

export const formatPayerGroup = (group: PayerGroupType | undefined) => {
  switch (group) {
    case "STUDENTS":
      return i18n.t("common:payerGroups.students");
    case "COMPANY":
      return i18n.t("common:payerGroups.company");
    case "GOVERNMENT":
      return i18n.t("common:payerGroups.government");
    case "INDIGENOUS_BAND":
      return i18n.t("common:payerGroups.indigenousBand");
    case "WORKER_COMPANY":
      return i18n.t("common:payerGroups.workerCompany");
    case "INSURANCE":
      return i18n.t("common:payerGroups.insurance");
    case "OTHER":
      return i18n.t("common:payerGroups.other");
    default:
      return "";
  }
};

export const formatInvoiceDeliveryMethod = (
  method: InvoiceDeliveryMethodType | undefined,
) => {
  switch (method) {
    case "EMAIL":
      return i18n.t("common:invoiceDeliveryMethods.email");
    case "MAIL":
      return i18n.t("common:invoiceDeliveryMethods.mail");
    case "OTHER":
      return i18n.t("common:invoiceDeliveryMethods.other");
    case "NONE":
      return i18n.t("common:invoiceDeliveryMethods.none");
    default:
      return "";
  }
};
